import { getVehicleInfoById } from "Utils";

export interface InterectionEntityWithVehicleInfo extends IntersectionEntity {
  vehicle_name: string;
  vehicle_link: string | undefined;
  mission_name?: string;
}

export interface IntersectionNamePermission {
  id: string;
  name: string;
  activePermissions: InterectionEntityWithVehicleInfo[];
}

export function buildIntersectionNameAndPermissionsMap(
  intersections: Record<string, string>,
  permissions: IntersectionEntity[],
  vehicles: Vehicle[],
  vehicleTypes: VehicleType[],
  missionsByVehicleId: Record<string, Mission>
): IntersectionNamePermission[] {
  const data: Record<string, IntersectionNamePermission> = {};

  for (const [key, name] of Object.entries(intersections)) {
    const targetPermissons = permissions.filter(
      (each) => each.intersection_id === parseInt(key)
    );
    data[key] = {
      id: key,
      name,
      activePermissions: targetPermissons.map((each) => {
        const { vehicle_id } = each;
        const { name, link } = getVehicleInfoById(
          vehicle_id,
          vehicles,
          vehicleTypes
        );
        const mission = missionsByVehicleId[vehicle_id];
        return {
          vehicle_name: name,
          vehicle_link: link,
          mission_name: mission?.name,
          ...each,
        };
      }),
    };
  }
  return Object.values(data).sort(
    (a, b) => b.activePermissions.length - a.activePermissions.length
  );
}
